export default "__VITE_ASSET__BhzFq9Ni__"